// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#progress-bar[data-v-6827eb67] {position:absolute;right:1rem;left:1rem;top:-10px;z-index:10}", ""]);
// Exports
module.exports = exports;
